import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import { listProjects } from '@/features/projects/projects-api'
import { projectsQueryKey } from '@/features/projects/projects-query-keys'
import {
  type RealtimeChannel,
  useRealtimeSubscriptions,
} from '@/shared/realtime/use-realtime-subscriptions'

/**
 * Подписывает на канал conversations по всем проектам пользователя и вызывает
 * onEvent на каждое realtime-событие. Общий каркас для счётчиков (очередь,
 * непрочитанные) — единый источник паттерна подписки.
 */
export function useProjectConversationsRealtime(
  onEvent: (event: { channel: string; event: string; payload: unknown }) => void,
  enabled: boolean,
): void {
  const projectsQuery = useQuery({
    queryKey: projectsQueryKey,
    queryFn: () => listProjects(),
    enabled,
  })

  const channels = useMemo<RealtimeChannel[]>(
    () =>
      (projectsQuery.data || []).map((project) => ({
        name: `projects.${project.id}.conversations`,
        private: true,
      })),
    [projectsQuery.data],
  )

  useRealtimeSubscriptions({ channels, enabled, onEvent })
}
